import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import qs from 'query-string';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCreateReportModalOpen, setPowerBiImportModalOpen } from '../../actions/PowerBIActions';
import { MASTER_DATASET_REPORT_STATUS } from '../../constants/PowerBIConstants';
import { POWERBI_EDITOR_PAGE, POWERBI_REPORT_PAGE } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsImportAvailable } from '../../selectors/PowerBISelectors';
import Link from '../Link';

const useStyles = makeStyles({
  modal: {
    minWidth: '30%',
    zIndex: 1200,
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  button: {
    width: 90,
    marginRight: 10,
  },
});

const ReportActionsCell = ({ row }) => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const hasImportRight = useSelector(getIsImportAvailable);

  const isSystemDefinedReport = Number(row.QI_IS_SYSTEM_DEFINED);
  const isReportFileUploaded = row.QI_REPORT_FILE_NAME;
  const isMasterDatasetReport = row.QI_STATUS.toLowerCase() === MASTER_DATASET_REPORT_STATUS;

  //no buttons should be shown for Mater Dataset reports
  if (isMasterDatasetReport) {
    return null;
  }

  const editorLink = `${POWERBI_EDITOR_PAGE}?${qs.stringify({
    reportName: row.QI_REPORT_TITLE,
    itmId: row.ItmId,
    entityName: row.EntityName,
  })}`;

  const previewLink = `${POWERBI_REPORT_PAGE}?${qs.stringify({
    reportName: row.QI_REPORT_TITLE,
    itmId: row.ItmId,
    entityName: row.EntityName,
    useUnpublished: true,
  })}`;

  const showImportButton = hasImportRight && !isSystemDefinedReport;
  const showAddButton = !isReportFileUploaded && !isSystemDefinedReport;
  const showEditButton = isReportFileUploaded && !isSystemDefinedReport;

  return (
    <div className={classes.buttonContainer}>
      <Button
        component={Link}
        variant="primary"
        size="small"
        to={previewLink}
        target="_blank"
        disabled={!row.QI_REPORT_FILE_NAME}
        className={classes.button}
      >
        {translateString('Preview')}
      </Button>
      {showImportButton && (
        <Button
          variant="primary"
          size="small"
          className={classes.button}
          onClick={() => dispatch(setPowerBiImportModalOpen(true, row.PK_ID))}
        >
          {translateString('Import')}
        </Button>
      )}
      {showAddButton && (
        <Button
          variant="primary"
          size="small"
          onClick={() =>
            dispatch(
              setCreateReportModalOpen(true, {
                itmId: row.ItmId,
                reportName: row.QI_REPORT_TITLE,
                entityName: row.EntityName,
              })
            )
          }
          className={classes.button}
        >
          {translateString('Add Report')}
        </Button>
      )}
      {showEditButton && (
        <Button
          component={Link}
          variant="primary"
          size="small"
          target="_self"
          to={editorLink}
          className={classes.button}
        >
          {translateString('Edit Report')}
        </Button>
      )}
    </div>
  );
};

export default ReportActionsCell;
